const liaisonText = {
  heading: 'Get in touch with our sales department',
  text: 'We invite individual and business clients to cooperate with RC-Medical. We carry out wholesale and retail orders and offer the possibility of partnership cooperation in Poland and abroad.',
};

export { liaisonText };